/**
 * `SiteStat` — ported from `Foyer_Dashboard_CURRENT.jsx` line 990.
 * Three-up stat tile used on `SiteCard`.
 */

import { useC } from '../../lib/theme.js';

const monoFont = "'JetBrains Mono', monospace";
const serifFont = "'Instrument Serif', serif";

export interface SiteStatProps {
  label: string;
  value: string | number;
}

export function SiteStat({ label, value }: SiteStatProps): JSX.Element {
  const C = useC();
  return (
    <div>
      <div
        style={{
          fontFamily: monoFont,
          fontSize: 9,
          color: C.muted,
          letterSpacing: 1,
          marginBottom: 4,
        }}
      >
        {label.toUpperCase()}
      </div>
      <div
        style={{
          fontFamily: serifFont,
          fontSize: 22,
          color: C.text,
          lineHeight: 1,
          letterSpacing: -0.5,
        }}
      >
        {typeof value === 'number' ? value.toLocaleString('en-US') : value}
      </div>
    </div>
  );
}
